// https://popper.js.org/popper-documentation.html#Popper.placements
export const TOP = 'top';
export const TOP_START = 'top-start';
export const TOP_END = 'top-end';
export const BOTTOM = 'bottom';
export const BOTTOM_START = 'bottom-start';
export const BOTTOM_END = 'bottom-end';
export const LEFT = 'left';
export const LEFT_START = 'left-start';
export const LEFT_END = 'left-end';
export const RIGHT = 'right';
export const RIGHT_START = 'right-start';
export const RIGHT_END = 'right-end';
